import { cx } from "../../../utils/classNames";
import { getFieldId } from "../performanceUtils";
import RatingSection from "./RatingSection";
import TextListSection from "./TextListSection";
import TableSection from "./TableSection";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Performance.module.css";

const TextSection = ({ answer = {}, onChange }) =>
  onChange ? (
    <textarea
      rows={4}
      maxLength={10000}
      className={cx(ui.input, ui.textarea)}
      value={answer.text ?? ""}
      onChange={(e) => onChange({ ...answer, text: e.target.value })}
    />
  ) : answer.text?.trim() ? (
    <p className={styles.readOnlyText}>{answer.text}</p>
  ) : (
    <p className={cx(ui.muted, "mb-0")}>Nothing entered.</p>
  );

const SECTION_COMPONENTS = {
  RATING: RatingSection,
  TEXT_LIST: TextListSection,
  TABLE: TableSection,
  TEXT: TextSection,
};

// Renders an evaluation form from its `sections` definition.
//   onChange(nextResponses) present -> editable; absent -> read-only.
//   selfResponses -> "Self: N" chips next to ratings.
const EvaluationForm = ({
  sections,
  responses = {},
  onChange,
  selfResponses,
}) => (
  <div className={ui.card}>
    {sections.map((section) => {
      const Section = SECTION_COMPONENTS[section.type];
      if (!Section) return null;

      return (
        <section
          key={section.key}
          id={getFieldId(section.key)}
          className={styles.section}
        >
          <div className={styles.sectionHeader}>
            <h5 className={styles.sectionTitle}>
              {section.title}
              {section.required && section.type !== "RATING" && " *"}
            </h5>
            {section.type === "RATING" && (
              <span className={styles.sectionMeta}>
                {section.weight}% of total · scale {section.scale?.min}–
                {section.scale?.max}
              </span>
            )}
          </div>
          {section.description && (
            <p className={styles.sectionDescription}>{section.description}</p>
          )}

          <Section
            section={section}
            answer={responses[section.key]}
            selfAnswer={selfResponses?.[section.key]}
            onChange={
              onChange &&
              ((answer) => onChange({ ...responses, [section.key]: answer }))
            }
          />
        </section>
      );
    })}
  </div>
);

export default EvaluationForm;
